// Utility to clear Auth0 cached state and force clean authentication
export const clearAuth0State = () => {
  console.log('🧹 Clearing all Auth0 state and cache...');
  
  // Clear all Auth0 localStorage keys
  const keysToRemove = [
    '@@auth0spajs@@::m9mqRYRXS75BOybSgDqW7RUCtsd6evqn::@@user@@',
    '@@auth0spajs@@::m9mqRYRXS75BOybSgDqW7RUCtsd6evqn::@@cache@@',
    '@@auth0spajs@@::m9mqRYRXS75BOybSgDqW7RUCtsd6evqn::@@nonce@@',
    '@@auth0spajs@@::m9mqRYRXS75BOybSgDqW7RUCtsd6evqn::@@state@@',
    '@@auth0spajs@@::m9mqRYRXS75BOybSgDqW7RUCtsd6evqn::@@code_verifier@@',
    '@@auth0spajs@@::m9mqRYRXS75BOybSgDqW7RUCtsd6evqn::@@scope@@',
    '@@auth0spajs@@::m9mqRYRXS75BOybSgDqW7RUCtsd6evqn::@@audience@@',
    '@@auth0spajs@@::m9mqRYRXS75BOybSgDqW7RUCtsd6evqn::@@expires_at@@',
    '@@auth0spajs@@::m9mqRYRXS75BOybSgDqW7RUCtsd6evqn::@@id_token@@',
    '@@auth0spajs@@::m9mqRYRXS75BOybSgDqW7RUCtsd6evqn::@@access_token@@',
    '@@auth0spajs@@::m9mqRYRXS75BOybSgDqW7RUCtsd6evqn::@@refresh_token@@'
  ];
  
  // Clear specific keys
  keysToRemove.forEach(key => {
    if (localStorage.getItem(key)) {
      console.log(`🗑️ Removing: ${key}`);
      localStorage.removeItem(key);
    }
  });
  
  // Clear all localStorage keys that start with @@auth0spajs@@
  const allKeys = Object.keys(localStorage);
  allKeys.forEach(key => {
    if (key.startsWith('@@auth0spajs@@')) {
      console.log(`🗑️ Removing Auth0 key: ${key}`);
      localStorage.removeItem(key);
    }
  });
  
  // Clear sessionStorage Auth0 data
  const sessionKeys = Object.keys(sessionStorage);
  sessionKeys.forEach(key => {
    if (key.includes('auth0') || key.includes('@@auth0spajs@@')) {
      console.log(`🗑️ Removing sessionStorage Auth0 key: ${key}`);
      sessionStorage.removeItem(key);
    }
  });
  
  // Clear any auth-related cookies
  document.cookie.split(";").forEach(function(c) { 
    document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); 
  });
  
  console.log('✅ Auth0 state clearing complete');
};

// Auto-clear function that can be called on page load if needed
export const autoCleanAuth0State = () => {
  // Check if we're in a stuck state (on root page but should be authenticated)
  const isRootPage = window.location.pathname === '/';
  const hasAuth0Cache = localStorage.getItem('@@auth0spajs@@::m9mqRYRXS75BOybSgDqW7RUCtsd6evqn::@@user@@');
  
  if (isRootPage && hasAuth0Cache) {
    console.log('Detected potential Auth0 cache issue, clearing state...');
    clearAuth0State();
    // Force reload to start fresh
    window.location.reload();
  }
}; 